// extracted by mini-css-extract-plugin
export var evenement = "detailsEvent-module--evenement--dea32";
export var eventContent = "detailsEvent-module--event-content--30b6a";
export var eventDate = "detailsEvent-module--event-date--b0730";
export var eventDateFrom = "detailsEvent-module--event-date-from--fd83a";
export var eventDateTo = "detailsEvent-module--event-date-to--1d3e5";
export var eventFooter = "detailsEvent-module--event-footer--f428f";
export var eventFooterBack = "detailsEvent-module--event-footer-back--5b699";
export var eventImg = "detailsEvent-module--event-img--9c7a5";
export var eventPlace = "detailsEvent-module--event-place--0e08d";
export var eventPlaceIcon = "detailsEvent-module--event-place-icon--a3646";
export var eventPlaceTitle = "detailsEvent-module--event-place-title--f668c";
export var eventTaxo = "detailsEvent-module--event-taxo--ca508";
export var eventTitle = "detailsEvent-module--event-title--7a2fe";
export var pageEvent = "detailsEvent-module--page-event--debac";
export var pageEventAdditionalInfos = "detailsEvent-module--page-event-additional-infos--e2459";